<template>
    <v-card class="pt-4 pb-4" elevation="4">
        <v-row class="ma-0 pa-0" style="cursor: pointer;" @click="apriPaginaEventi()">
            <v-spacer />
            <span>
                Comunicazioni
            </span>
            <v-spacer />
        </v-row>

        <v-row class="ma-0 pa-0">
            <!-- Colonna Eventi Oggi -->
            <!-- <v-col cols="12">
                <h3 class="mb-2" style="cursor: pointer;" @click="apriPaginaEventi()">📅 Oggi</h3>
                <v-list two-line dense>
                    <template v-if="attivitaOggi && attivitaOggi.length">
                        <v-list-item v-for="(evento, i) in attivitaOggi" :key="'oggi-' + i" @click="apriEvento(evento)"
                            class="evento-item ma-0 pa-0" :class="getEventoStatusClass(evento)">
                            <v-list-item-content>
                                <v-list-item-title>
                                    <v-icon v-if="evento.utenti && evento.utenti.split(',').length > 1" small
                                        class="ml-0" v-tooltip.bottom="'Partecipanti: ' + evento.utenti">
                                        people_alt
                                    </v-icon>
                                    {{ evento.descrizione }}
                                </v-list-item-title>

                                <v-list-item-subtitle>
                                    {{ evento.oraInizio ? evento.oraInizio + '-' + evento.oraFine : 'Tutto il giorno' }}
                                    <br />
                                    {{ evento.ragSoc }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </template>


<template v-else>
                        <v-list-item class="ma-0 pa-0">
                            <v-list-item-content class="text--disabled">
                                Nessun evento per oggi
                            </v-list-item-content>
                        </v-list-item>
                    </template>
</v-list>
</v-col> -->
        </v-row>
    </v-card>
</template>

<script>
import storage from "@/services/storage.js";
import { get_tasks } from "@/api/api.calendar.js"

export default {

    data: () => ({
        attivitaOggi: [],
        attivitaProssime: [],
    }),

    methods: {
        async caricaDati() {
            let res = await get_tasks("oggi");
            this.attivitaOggi = res.data;

            res = await get_tasks("recenti");
            this.attivitaProssime = res.data;
        },

        apriEvento(evento) {
            let url = "/calendar?tool=tasks&data=" + encodeURIComponent(evento.data) + "&prog=" + evento.prog.toString()
            this.$router.push({ path: url });
        },

        apriPaginaEventi() {
            let url = "/calendar?tool=tasks"
            this.$router.push({ path: url });
        },

        getEventoStatusClass(evento) {
            let now = new Date();
            let eventoData = evento.data.substring(0, 10);
            let oraInizio = evento.oraInizio || "00:00";
            let oraFine = evento.oraFine || "23:59";
            let start = new Date(`${eventoData}T${oraInizio}:00`);
            let end = new Date(`${eventoData}T${oraFine}:00`);

            if (now < start) return "evento-futuro";
            else if (now >= start && now <= end) return "evento-ongoing";
            else return "evento-passato";
        },

    },

    mounted() {
        this.caricaDati();
    },
    computed: {
        userName() {
            return storage.getUsername();
        },
    }
}

</script>

<style scoped>
.evento-item {
    cursor: pointer;
    transition: background-color 0.2s;
}

.evento-item {
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
}

/* FUTURO */
.evento-futuro {
    border-left: 4px solid #42a5f5;
    /* blu chiaro */
    background-color: rgba(66, 165, 245, 0.08);
}

/* IN CORSO */
.evento-ongoing {
    border-left: 4px solid #66bb6a;
    /* verde */
    background-color: rgba(102, 187, 106, 0.15);
}

/* PASSATO */
.evento-passato {
    border-left: 4px solid #ef5350;
    /* rosso */
    background-color: rgba(239, 83, 80, 0.08);
    opacity: 0.8;
    /* leggermente attenuato */
}
</style>